export type Json =
  | string
  | number
  | boolean
  | null
  | { [key: string]: Json | undefined }
  | Json[];

export type Database = {
  graphql_public: {
    Tables: {
      [_ in never]: never;
    };
    Views: {
      [_ in never]: never;
    };
    Functions: {
      graphql: {
        Args: {
          extensions?: Json;
          operationName?: string;
          query?: string;
          variables?: Json;
        };
        Returns: Json;
      };
    };
    Enums: {
      [_ in never]: never;
    };
    CompositeTypes: {
      [_ in never]: never;
    };
  };
  public: {
    Tables: {
      chart_config_kpis: {
        Row: {
          chart_config_id: number;
          derivative_kpi_id: number | null;
          id: number;
          kpi_id: number | null;
        };
        Insert: {
          chart_config_id: number;
          derivative_kpi_id?: number | null;
          id?: number;
          kpi_id?: number | null;
        };
        Update: {
          chart_config_id?: number;
          derivative_kpi_id?: number | null;
          id?: number;
          kpi_id?: number | null;
        };
        Relationships: [
          {
            foreignKeyName: 'chart_config_kpis_chart_config_id_fkey';
            columns: ['chart_config_id'];
            isOneToOne: false;
            referencedRelation: 'chart_configs';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'chart_config_kpis_derivative_kpi_id_fkey';
            columns: ['derivative_kpi_id'];
            isOneToOne: false;
            referencedRelation: 'derivative_kpis';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'chart_config_kpis_kpi_id_fkey';
            columns: ['kpi_id'];
            isOneToOne: false;
            referencedRelation: 'project_kpis';
            referencedColumns: ['id'];
          },
        ];
      };
      chart_configs: {
        Row: {
          aggregation_type: string;
          chart_config: Json | null;
          chart_type: string;
          config_type: string;
          created_at: string;
          created_by: string | null;
          creator_orga_id: number;
          id: number;
          project_id: number;
          title: string | null;
          updated_at: string | null;
          updated_by: string | null;
        };
        Insert: {
          aggregation_type: string;
          chart_config?: Json | null;
          chart_type: string;
          config_type: string;
          created_at?: string;
          created_by?: string | null;
          creator_orga_id: number;
          id?: number;
          project_id: number;
          title?: string | null;
          updated_at?: string | null;
          updated_by?: string | null;
        };
        Update: {
          aggregation_type?: string;
          chart_config?: Json | null;
          chart_type?: string;
          config_type?: string;
          created_at?: string;
          created_by?: string | null;
          creator_orga_id?: number;
          id?: number;
          project_id?: number;
          title?: string | null;
          updated_at?: string | null;
          updated_by?: string | null;
        };
        Relationships: [
          {
            foreignKeyName: 'chart_configs_creator_orga_id_fkey';
            columns: ['creator_orga_id'];
            isOneToOne: false;
            referencedRelation: 'orgs';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'chart_configs_project_id_fkey';
            columns: ['project_id'];
            isOneToOne: false;
            referencedRelation: 'projects';
            referencedColumns: ['id'];
          },
        ];
      };
      contractor_subproject_invitation: {
        Row: {
          created_at: string | null;
          created_by: string | null;
          deeplink_prefix: string | null;
          id: string;
          invitation_token: string;
          inviter_profile_id: string | null;
          kpis_ids: number[] | null;
          partner_id: string | null;
          status: string | null;
          subproject_client_view_id: number | null;
          to_email: string | null;
        };
        Insert: {
          created_at?: string | null;
          created_by?: string | null;
          deeplink_prefix?: string | null;
          id?: string;
          invitation_token?: string;
          inviter_profile_id?: string | null;
          kpis_ids?: number[] | null;
          partner_id?: string | null;
          status?: string | null;
          subproject_client_view_id?: number | null;
          to_email?: string | null;
        };
        Update: {
          created_at?: string | null;
          created_by?: string | null;
          deeplink_prefix?: string | null;
          id?: string;
          invitation_token?: string;
          inviter_profile_id?: string | null;
          kpis_ids?: number[] | null;
          partner_id?: string | null;
          status?: string | null;
          subproject_client_view_id?: number | null;
          to_email?: string | null;
        };
        Relationships: [
          {
            foreignKeyName: 'contractor_subproject_invitation_inviter_id_fkey';
            columns: ['inviter_profile_id'];
            isOneToOne: false;
            referencedRelation: 'profiles';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'contractor_subproject_invitation_partner_id_fkey';
            columns: ['partner_id'];
            isOneToOne: false;
            referencedRelation: 'partner_aliases';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'contractor_subproject_invitation_subproject_client_view_id_fkey';
            columns: ['subproject_client_view_id'];
            isOneToOne: false;
            referencedRelation: 'projects';
            referencedColumns: ['id'];
          },
        ];
      };
      contractor_view_invitation: {
        Row: {
          created_at: string;
          created_by: string | null;
          deeplink_prefix: string | null;
          id: string;
          invitation_token: string;
          org_member_id: string;
          status: string | null;
          subproject_contractor_view_id: number | null;
        };
        Insert: {
          created_at?: string;
          created_by?: string | null;
          deeplink_prefix?: string | null;
          id?: string;
          invitation_token?: string;
          org_member_id: string;
          status?: string | null;
          subproject_contractor_view_id?: number | null;
        };
        Update: {
          created_at?: string;
          created_by?: string | null;
          deeplink_prefix?: string | null;
          id?: string;
          invitation_token?: string;
          org_member_id?: string;
          status?: string | null;
          subproject_contractor_view_id?: number | null;
        };
        Relationships: [
          {
            foreignKeyName: 'contractor_view_invitation_org_member_id_fkey';
            columns: ['org_member_id'];
            isOneToOne: false;
            referencedRelation: 'org_members';
            referencedColumns: ['member_id'];
          },
          {
            foreignKeyName: 'contractor_view_invitation_subproject_contractor_view_id_fkey';
            columns: ['subproject_contractor_view_id'];
            isOneToOne: false;
            referencedRelation: 'projects';
            referencedColumns: ['id'];
          },
        ];
      };
      dashboard_project_slots: {
        Row: {
          created_at: string;
          org_id: number;
          slot_0_is_active: boolean;
          slot_0_project_id: number | null;
          slot_1_is_active: boolean;
          slot_1_project_id: number | null;
          slot_2_is_active: boolean;
          slot_2_project_id: number | null;
          slot_3_is_active: boolean;
          slot_3_project_id: number | null;
          updated_at: string;
        };
        Insert: {
          created_at?: string;
          org_id: number;
          slot_0_is_active?: boolean;
          slot_0_project_id?: number | null;
          slot_1_is_active?: boolean;
          slot_1_project_id?: number | null;
          slot_2_is_active?: boolean;
          slot_2_project_id?: number | null;
          slot_3_is_active?: boolean;
          slot_3_project_id?: number | null;
          updated_at?: string;
        };
        Update: {
          created_at?: string;
          org_id?: number;
          slot_0_is_active?: boolean;
          slot_0_project_id?: number | null;
          slot_1_is_active?: boolean;
          slot_1_project_id?: number | null;
          slot_2_is_active?: boolean;
          slot_2_project_id?: number | null;
          slot_3_is_active?: boolean;
          slot_3_project_id?: number | null;
          updated_at?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'dashboard_project_slots_org_id_fkey';
            columns: ['org_id'];
            isOneToOne: true;
            referencedRelation: 'orgs';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'dashboard_project_slots_slot_0_project_id_fkey';
            columns: ['slot_0_project_id'];
            isOneToOne: false;
            referencedRelation: 'projects';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'dashboard_project_slots_slot_1_project_id_fkey';
            columns: ['slot_1_project_id'];
            isOneToOne: false;
            referencedRelation: 'projects';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'dashboard_project_slots_slot_2_project_id_fkey';
            columns: ['slot_2_project_id'];
            isOneToOne: false;
            referencedRelation: 'projects';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'dashboard_project_slots_slot_3_project_id_fkey';
            columns: ['slot_3_project_id'];
            isOneToOne: false;
            referencedRelation: 'projects';
            referencedColumns: ['id'];
          },
        ];
      };
      derivative_kpis: {
        Row: {
          created_at: string;
          custom_operand_1: number | null;
          custom_operand_2: number | null;
          id: number;
          kpi_operand_1: number | null;
          kpi_operand_2: number | null;
          max_value: number | null;
          name: string;
          operation: Database['public']['Enums']['math_operation'];
          project_id: number;
          type: string;
          unit: string;
        };
        Insert: {
          created_at?: string;
          custom_operand_1?: number | null;
          custom_operand_2?: number | null;
          id?: number;
          kpi_operand_1?: number | null;
          kpi_operand_2?: number | null;
          max_value?: number | null;
          name: string;
          operation: Database['public']['Enums']['math_operation'];
          project_id: number;
          type: string;
          unit: string;
        };
        Update: {
          created_at?: string;
          custom_operand_1?: number | null;
          custom_operand_2?: number | null;
          id?: number;
          kpi_operand_1?: number | null;
          kpi_operand_2?: number | null;
          max_value?: number | null;
          name?: string;
          operation?: Database['public']['Enums']['math_operation'];
          project_id?: number;
          type?: string;
          unit?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'derivative_kpis_kpi_operand_1_fkey';
            columns: ['kpi_operand_1'];
            isOneToOne: false;
            referencedRelation: 'project_kpis';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'derivative_kpis_kpi_operand_2_fkey';
            columns: ['kpi_operand_2'];
            isOneToOne: false;
            referencedRelation: 'project_kpis';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'derivative_kpis_project_id_fkey';
            columns: ['project_id'];
            isOneToOne: false;
            referencedRelation: 'projects';
            referencedColumns: ['id'];
          },
        ];
      };
      email_notifications: {
        Row: {
          created_at: string | null;
          deeplink_prefix: string | null;
          email_type: string;
          id: string;
          metadata: Json;
          recipient_email: string;
          recipient_language: string | null;
          recipient_name: string | null;
        };
        Insert: {
          created_at?: string | null;
          deeplink_prefix?: string | null;
          email_type: string;
          id?: string;
          metadata?: Json;
          recipient_email: string;
          recipient_language?: string | null;
          recipient_name?: string | null;
        };
        Update: {
          created_at?: string | null;
          deeplink_prefix?: string | null;
          email_type?: string;
          id?: string;
          metadata?: Json;
          recipient_email?: string;
          recipient_language?: string | null;
          recipient_name?: string | null;
        };
        Relationships: [];
      };
      integration_token_logs: {
        Row: {
          action: string;
          created_at: string;
          id: number;
          metadata: Json | null;
          token_id: number | null;
        };
        Insert: {
          action: string;
          created_at?: string;
          id?: number;
          metadata?: Json | null;
          token_id?: number | null;
        };
        Update: {
          action?: string;
          created_at?: string;
          id?: number;
          metadata?: Json | null;
          token_id?: number | null;
        };
        Relationships: [];
      };
      kpi_anomalies: {
        Row: {
          aggregated_value: number;
          created_at: string;
          detected_at: string;
          deviation_percentage: number | null;
          forecast_value: number | null;
          id: number;
          is_anomaly: boolean;
          kpi_id: number;
          last_entry_created_at: string;
          lower_bound: number | null;
          period: string;
          period_type: Database['public']['Enums']['period_type'];
          project_id: number | null;
          report_id: number | null;
          updated_at: string | null;
          upper_bound: number | null;
        };
        Insert: {
          aggregated_value: number;
          created_at?: string;
          detected_at?: string;
          deviation_percentage?: number | null;
          forecast_value?: number | null;
          id?: number;
          is_anomaly?: boolean;
          kpi_id: number;
          last_entry_created_at: string;
          lower_bound?: number | null;
          period: string;
          period_type: Database['public']['Enums']['period_type'];
          project_id?: number | null;
          report_id?: number | null;
          updated_at?: string | null;
          upper_bound?: number | null;
        };
        Update: {
          aggregated_value?: number;
          created_at?: string;
          detected_at?: string;
          deviation_percentage?: number | null;
          forecast_value?: number | null;
          id?: number;
          is_anomaly?: boolean;
          kpi_id?: number;
          last_entry_created_at?: string;
          lower_bound?: number | null;
          period?: string;
          period_type?: Database['public']['Enums']['period_type'];
          project_id?: number | null;
          report_id?: number | null;
          updated_at?: string | null;
          upper_bound?: number | null;
        };
        Relationships: [
          {
            foreignKeyName: 'kpi_anomalies_kpi_id_fkey';
            columns: ['kpi_id'];
            isOneToOne: false;
            referencedRelation: 'project_kpis';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'kpi_anomalies_project_id_fkey';
            columns: ['project_id'];
            isOneToOne: false;
            referencedRelation: 'projects';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'kpi_anomalies_report_id_fkey';
            columns: ['report_id'];
            isOneToOne: false;
            referencedRelation: 'kpi_tracking_reports';
            referencedColumns: ['id'];
          },
        ];
      };
      kpi_forecasts: {
        Row: {
          calculated_at: string;
          confidence: number;
          created_at: string;
          forecast_value: number;
          id: number;
          kpi_id: number;
          last_entry_created_at: string;
          lower_bound: number;
          method_weights: Json;
          period: string;
          period_type: Database['public']['Enums']['period_type'];
          previous_period_value: number | null;
          project_id: number | null;
          updated_at: string | null;
          upper_bound: number;
        };
        Insert: {
          calculated_at?: string;
          confidence: number;
          created_at?: string;
          forecast_value: number;
          id?: number;
          kpi_id: number;
          last_entry_created_at: string;
          lower_bound: number;
          method_weights?: Json;
          period: string;
          period_type?: Database['public']['Enums']['period_type'];
          previous_period_value?: number | null;
          project_id?: number | null;
          updated_at?: string | null;
          upper_bound: number;
        };
        Update: {
          calculated_at?: string;
          confidence?: number;
          created_at?: string;
          forecast_value?: number;
          id?: number;
          kpi_id?: number;
          last_entry_created_at?: string;
          lower_bound?: number;
          method_weights?: Json;
          period?: string;
          period_type?: Database['public']['Enums']['period_type'];
          previous_period_value?: number | null;
          project_id?: number | null;
          updated_at?: string | null;
          upper_bound?: number;
        };
        Relationships: [
          {
            foreignKeyName: 'kpi_forecasts_kpi_id_fkey';
            columns: ['kpi_id'];
            isOneToOne: false;
            referencedRelation: 'project_kpis';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'kpi_forecasts_project_id_fkey';
            columns: ['project_id'];
            isOneToOne: false;
            referencedRelation: 'projects';
            referencedColumns: ['id'];
          },
        ];
      };
      kpi_tracking_entries: {
        Row: {
          created_at: string;
          created_by: string | null;
          id: number;
          kpi_id: number | null;
          project_id: number;
          report_id: number;
          updated_at: string | null;
          updated_by: string | null;
          value: number | null;
        };
        Insert: {
          created_at?: string;
          created_by?: string | null;
          id?: number;
          kpi_id?: number | null;
          project_id: number;
          report_id: number;
          updated_at?: string | null;
          updated_by?: string | null;
          value?: number | null;
        };
        Update: {
          created_at?: string;
          created_by?: string | null;
          id?: number;
          kpi_id?: number | null;
          project_id?: number;
          report_id?: number;
          updated_at?: string | null;
          updated_by?: string | null;
          value?: number | null;
        };
        Relationships: [
          {
            foreignKeyName: 'kpi_tracking_entries_kpi_id_fkey';
            columns: ['kpi_id'];
            isOneToOne: false;
            referencedRelation: 'project_kpis';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'kpi_tracking_entries_project_id_fkey';
            columns: ['project_id'];
            isOneToOne: false;
            referencedRelation: 'projects';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'kpi_tracking_entries_report_id_fkey';
            columns: ['report_id'];
            isOneToOne: false;
            referencedRelation: 'kpi_tracking_reports';
            referencedColumns: ['id'];
          },
        ];
      };
      kpi_tracking_report_comments: {
        Row: {
          author_org_id: number;
          author_profile_id: string | null;
          created_at: string;
          id: number;
          message: string;
          project_id: number;
          seen: boolean;
          tracking_report_id: number;
        };
        Insert: {
          author_org_id: number;
          author_profile_id?: string | null;
          created_at?: string;
          id?: number;
          message: string;
          project_id: number;
          seen?: boolean;
          tracking_report_id: number;
        };
        Update: {
          author_org_id?: number;
          author_profile_id?: string | null;
          created_at?: string;
          id?: number;
          message?: string;
          project_id?: number;
          seen?: boolean;
          tracking_report_id?: number;
        };
        Relationships: [
          {
            foreignKeyName: 'kpi_tracking_entry_comments_author_org_id_fkey';
            columns: ['author_org_id'];
            isOneToOne: false;
            referencedRelation: 'orgs';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'kpi_tracking_entry_comments_tracking_entry_id_fkey';
            columns: ['tracking_report_id'];
            isOneToOne: false;
            referencedRelation: 'kpi_tracking_entries';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'kpi_tracking_report_comments_author_profile_id_fkey';
            columns: ['author_profile_id'];
            isOneToOne: false;
            referencedRelation: 'profiles';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'kpi_tracking_report_comments_project_id_fkey';
            columns: ['project_id'];
            isOneToOne: false;
            referencedRelation: 'projects';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'kpi_tracking_report_comments_tracking_report_id_fkey';
            columns: ['tracking_report_id'];
            isOneToOne: false;
            referencedRelation: 'kpi_tracking_reports';
            referencedColumns: ['id'];
          },
        ];
      };
      kpi_tracking_report_documents: {
        Row: {
          document_id: number;
          report_id: number;
        };
        Insert: {
          document_id: number;
          report_id: number;
        };
        Update: {
          document_id?: number;
          report_id?: number;
        };
        Relationships: [
          {
            foreignKeyName: 'kpi_tracking_report_documents_document_id_fkey';
            columns: ['document_id'];
            isOneToOne: false;
            referencedRelation: 'project_documents';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'kpi_tracking_report_documents_report_id_fkey';
            columns: ['report_id'];
            isOneToOne: false;
            referencedRelation: 'kpi_tracking_reports';
            referencedColumns: ['id'];
          },
        ];
      };
      kpi_tracking_reports: {
        Row: {
          created_at: string;
          created_by: string | null;
          created_by_token: number | null;
          description: string | null;
          id: number;
          project_id: number;
          updated_at: string | null;
        };
        Insert: {
          created_at?: string;
          created_by?: string | null;
          created_by_token?: number | null;
          description?: string | null;
          id?: number;
          project_id: number;
          updated_at?: string | null;
        };
        Update: {
          created_at?: string;
          created_by?: string | null;
          created_by_token?: number | null;
          description?: string | null;
          id?: number;
          project_id?: number;
          updated_at?: string | null;
        };
        Relationships: [
          {
            foreignKeyName: 'kpi_tracking_reports_created_by_token_fkey';
            columns: ['created_by_token'];
            isOneToOne: false;
            referencedRelation: 'org_integration_tokens';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'kpi_tracking_reports_project_id_fkey';
            columns: ['project_id'];
            isOneToOne: false;
            referencedRelation: 'projects';
            referencedColumns: ['id'];
          },
        ];
      };
      notification_read_status: {
        Row: {
          notification_id: number;
          read_at: string | null;
          user_id: string;
        };
        Insert: {
          notification_id: number;
          read_at?: string | null;
          user_id: string;
        };
        Update: {
          notification_id?: number;
          read_at?: string | null;
          user_id?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'notification_read_status_notification_id_fkey';
            columns: ['notification_id'];
            isOneToOne: false;
            referencedRelation: 'notifications';
            referencedColumns: ['id'];
          },
        ];
      };
      notifications: {
        Row: {
          content_category:
            | Database['public']['Enums']['notification_content_category']
            | null;
          content_type: string;
          created_at: string | null;
          id: number;
          metadata: Json | null;
          org_id: number;
          type: string;
          user_id: string | null;
        };
        Insert: {
          content_category?:
            | Database['public']['Enums']['notification_content_category']
            | null;
          content_type: string;
          created_at?: string | null;
          id?: number;
          metadata?: Json | null;
          org_id: number;
          type: string;
          user_id?: string | null;
        };
        Update: {
          content_category?:
            | Database['public']['Enums']['notification_content_category']
            | null;
          content_type?: string;
          created_at?: string | null;
          id?: number;
          metadata?: Json | null;
          org_id?: number;
          type?: string;
          user_id?: string | null;
        };
        Relationships: [
          {
            foreignKeyName: 'notifications_org_id_fkey';
            columns: ['org_id'];
            isOneToOne: false;
            referencedRelation: 'orgs';
            referencedColumns: ['id'];
          },
        ];
      };
      org_billing: {
        Row: {
          org_id: number;
          stripe_customer_id: string | null;
        };
        Insert: {
          org_id: number;
          stripe_customer_id?: string | null;
        };
        Update: {
          org_id?: number;
          stripe_customer_id?: string | null;
        };
        Relationships: [
          {
            foreignKeyName: 'org_billing_org_id_fkey';
            columns: ['org_id'];
            isOneToOne: true;
            referencedRelation: 'orgs';
            referencedColumns: ['id'];
          },
        ];
      };
      org_integration_tokens: {
        Row: {
          created_at: string;
          created_by: string | null;
          expires_at: string;
          id: number;
          last_used_at: string | null;
          org_id: number | null;
          project_id: number;
          title: string | null;
          token: string;
          type: string;
        };
        Insert: {
          created_at?: string;
          created_by?: string | null;
          expires_at?: string;
          id?: number;
          last_used_at?: string | null;
          org_id?: number | null;
          project_id: number;
          title?: string | null;
          token: string;
          type?: string;
        };
        Update: {
          created_at?: string;
          created_by?: string | null;
          expires_at?: string;
          id?: number;
          last_used_at?: string | null;
          org_id?: number | null;
          project_id?: number;
          title?: string | null;
          token?: string;
          type?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'org_integration_tokens_org_id_fkey';
            columns: ['org_id'];
            isOneToOne: false;
            referencedRelation: 'orgs';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'org_integration_tokens_project_id_fkey';
            columns: ['project_id'];
            isOneToOne: false;
            referencedRelation: 'projects';
            referencedColumns: ['id'];
          },
        ];
      };
      org_member_invites: {
        Row: {
          created_at: string;
          created_by: string | null;
          deeplink_prefix: string | null;
          email: string;
          expires_at: string | null;
          id: number;
          invitation_token: string;
          inviter_id: string | null;
          org_id: number;
          role: string;
          status: Database['public']['Enums']['invitation_status'] | null;
        };
        Insert: {
          created_at?: string;
          created_by?: string | null;
          deeplink_prefix?: string | null;
          email: string;
          expires_at?: string | null;
          id?: number;
          invitation_token?: string;
          inviter_id?: string | null;
          org_id: number;
          role: string;
          status?: Database['public']['Enums']['invitation_status'] | null;
        };
        Update: {
          created_at?: string;
          created_by?: string | null;
          deeplink_prefix?: string | null;
          email?: string;
          expires_at?: string | null;
          id?: number;
          invitation_token?: string;
          inviter_id?: string | null;
          org_id?: number;
          role?: string;
          status?: Database['public']['Enums']['invitation_status'] | null;
        };
        Relationships: [
          {
            foreignKeyName: 'org_member_invites_org_id_fkey';
            columns: ['org_id'];
            isOneToOne: false;
            referencedRelation: 'orgs';
            referencedColumns: ['id'];
          },
        ];
      };
      org_members: {
        Row: {
          created_at: string;
          member_id: string;
          org_id: number;
          profile_id: string | null;
          role: string;
          user_id: string;
        };
        Insert: {
          created_at?: string;
          member_id?: string;
          org_id: number;
          profile_id?: string | null;
          role: string;
          user_id: string;
        };
        Update: {
          created_at?: string;
          member_id?: string;
          org_id?: number;
          profile_id?: string | null;
          role?: string;
          user_id?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'org_members_org_id_fkey';
            columns: ['org_id'];
            isOneToOne: false;
            referencedRelation: 'orgs';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'org_members_profile_id_fkey';
            columns: ['profile_id'];
            isOneToOne: false;
            referencedRelation: 'profiles';
            referencedColumns: ['id'];
          },
        ];
      };
      org_plan_entitlements: {
        Row: {
          has_ai_features: boolean;
          has_unlimited_storage: boolean;
          plan_type: string;
          storage_limit: number | null;
        };
        Insert: {
          has_ai_features?: boolean;
          has_unlimited_storage?: boolean;
          plan_type: string;
          storage_limit?: number | null;
        };
        Update: {
          has_ai_features?: boolean;
          has_unlimited_storage?: boolean;
          plan_type?: string;
          storage_limit?: number | null;
        };
        Relationships: [];
      };
      organization_categories: {
        Row: {
          id: string;
          parent_id: string | null;
        };
        Insert: {
          id: string;
          parent_id?: string | null;
        };
        Update: {
          id?: string;
          parent_id?: string | null;
        };
        Relationships: [
          {
            foreignKeyName: 'organization_categories_parent_id_fkey';
            columns: ['parent_id'];
            isOneToOne: false;
            referencedRelation: 'organization_categories';
            referencedColumns: ['id'];
          },
        ];
      };
      organization_subscriptions: {
        Row: {
          billing_period: string;
          cancel_at: string | null;
          canceled_at: string | null;
          created_at: string | null;
          id: string;
          organization_id: number;
          plan_type: string;
          status: Database['public']['Enums']['stripe_status'];
          stripe_price_id: string | null;
          stripe_subscription_id: string | null;
          trial_end: string | null;
          updated_at: string | null;
        };
        Insert: {
          billing_period: string;
          cancel_at?: string | null;
          canceled_at?: string | null;
          created_at?: string | null;
          id?: string;
          organization_id: number;
          plan_type: string;
          status?: Database['public']['Enums']['stripe_status'];
          stripe_price_id?: string | null;
          stripe_subscription_id?: string | null;
          trial_end?: string | null;
          updated_at?: string | null;
        };
        Update: {
          billing_period?: string;
          cancel_at?: string | null;
          canceled_at?: string | null;
          created_at?: string | null;
          id?: string;
          organization_id?: number;
          plan_type?: string;
          status?: Database['public']['Enums']['stripe_status'];
          stripe_price_id?: string | null;
          stripe_subscription_id?: string | null;
          trial_end?: string | null;
          updated_at?: string | null;
        };
        Relationships: [
          {
            foreignKeyName: 'organization_subscriptions_organization_id_fkey';
            columns: ['organization_id'];
            isOneToOne: false;
            referencedRelation: 'orgs';
            referencedColumns: ['id'];
          },
        ];
      };
      orgs: {
        Row: {
          category_id: string | null;
          created_at: string;
          created_by: string | null;
          id: number;
          image_url: string | null;
          name: string | null;
          self_orga_user_id: string | null;
          subcategory_id: string | null;
        };
        Insert: {
          category_id?: string | null;
          created_at?: string;
          created_by?: string | null;
          id?: number;
          image_url?: string | null;
          name?: string | null;
          self_orga_user_id?: string | null;
          subcategory_id?: string | null;
        };
        Update: {
          category_id?: string | null;
          created_at?: string;
          created_by?: string | null;
          id?: number;
          image_url?: string | null;
          name?: string | null;
          self_orga_user_id?: string | null;
          subcategory_id?: string | null;
        };
        Relationships: [
          {
            foreignKeyName: 'orgs_category_id_fkey';
            columns: ['category_id'];
            isOneToOne: false;
            referencedRelation: 'organization_categories';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'orgs_subcategory_id_fkey';
            columns: ['subcategory_id'];
            isOneToOne: false;
            referencedRelation: 'organization_categories';
            referencedColumns: ['id'];
          },
        ];
      };
      partner_aliases: {
        Row: {
          alias: string;
          created_at: string | null;
          created_by: string | null;
          id: string;
          invited_email: string | null;
          owner_orga_id: number;
          partner_orga_id: number | null;
          updated_at: string | null;
          updated_by: string | null;
        };
        Insert: {
          alias: string;
          created_at?: string | null;
          created_by?: string | null;
          id?: string;
          invited_email?: string | null;
          owner_orga_id: number;
          partner_orga_id?: number | null;
          updated_at?: string | null;
          updated_by?: string | null;
        };
        Update: {
          alias?: string;
          created_at?: string | null;
          created_by?: string | null;
          id?: string;
          invited_email?: string | null;
          owner_orga_id?: number;
          partner_orga_id?: number | null;
          updated_at?: string | null;
          updated_by?: string | null;
        };
        Relationships: [
          {
            foreignKeyName: 'partner_aliases_owner_orga_id_fkey';
            columns: ['owner_orga_id'];
            isOneToOne: false;
            referencedRelation: 'orgs';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'partner_aliases_partner_orga_id_fkey';
            columns: ['partner_orga_id'];
            isOneToOne: false;
            referencedRelation: 'orgs';
            referencedColumns: ['id'];
          },
        ];
      };
      profiles: {
        Row: {
          avatar_url: string | null;
          created_at: string;
          email: string | null;
          fachbereich: string | null;
          first_name: string | null;
          funktion: string | null;
          id: string;
          language: Database['public']['Enums']['language'] | null;
          last_name: string | null;
          name: string | null;
          org_id: number | null;
          phone: string | null;
          telephone: string | null;
          user_id: string;
        };
        Insert: {
          avatar_url?: string | null;
          created_at?: string;
          email?: string | null;
          fachbereich?: string | null;
          first_name?: string | null;
          funktion?: string | null;
          id?: string;
          language?: Database['public']['Enums']['language'] | null;
          last_name?: string | null;
          name?: string | null;
          org_id?: number | null;
          phone?: string | null;
          telephone?: string | null;
          user_id: string;
        };
        Update: {
          avatar_url?: string | null;
          created_at?: string;
          email?: string | null;
          fachbereich?: string | null;
          first_name?: string | null;
          funktion?: string | null;
          id?: string;
          language?: Database['public']['Enums']['language'] | null;
          last_name?: string | null;
          name?: string | null;
          org_id?: number | null;
          phone?: string | null;
          telephone?: string | null;
          user_id?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'profiles_org_id_fkey';
            columns: ['org_id'];
            isOneToOne: false;
            referencedRelation: 'orgs';
            referencedColumns: ['id'];
          },
        ];
      };
      project_addon_assignments: {
        Row: {
          addon_id: string;
          created_at: string | null;
          id: string;
          project_id: number;
          updated_at: string | null;
        };
        Insert: {
          addon_id: string;
          created_at?: string | null;
          id?: string;
          project_id: number;
          updated_at?: string | null;
        };
        Update: {
          addon_id?: string;
          created_at?: string | null;
          id?: string;
          project_id?: number;
          updated_at?: string | null;
        };
        Relationships: [
          {
            foreignKeyName: 'project_addon_assignments_addon_id_fkey';
            columns: ['addon_id'];
            isOneToOne: false;
            referencedRelation: 'subscription_addons';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'project_addon_assignments_project_id_fkey';
            columns: ['project_id'];
            isOneToOne: false;
            referencedRelation: 'projects';
            referencedColumns: ['id'];
          },
        ];
      };
      project_categories: {
        Row: {
          id: string;
          level: number;
        };
        Insert: {
          id: string;
          level: number;
        };
        Update: {
          id?: string;
          level?: number;
        };
        Relationships: [];
      };
      project_contractors: {
        Row: {
          contractor_orga_id: number | null;
          created_at: string | null;
          created_by: string | null;
          id: string;
          partner_id: string | null;
          project_id: number | null;
          subproject_client_view_id: number | null;
          subproject_view_id: number | null;
          updated_at: string | null;
          updated_by: string | null;
        };
        Insert: {
          contractor_orga_id?: number | null;
          created_at?: string | null;
          created_by?: string | null;
          id?: string;
          partner_id?: string | null;
          project_id?: number | null;
          subproject_client_view_id?: number | null;
          subproject_view_id?: number | null;
          updated_at?: string | null;
          updated_by?: string | null;
        };
        Update: {
          contractor_orga_id?: number | null;
          created_at?: string | null;
          created_by?: string | null;
          id?: string;
          partner_id?: string | null;
          project_id?: number | null;
          subproject_client_view_id?: number | null;
          subproject_view_id?: number | null;
          updated_at?: string | null;
          updated_by?: string | null;
        };
        Relationships: [
          {
            foreignKeyName: 'project_contractors_contractor_orga_id_fkey';
            columns: ['contractor_orga_id'];
            isOneToOne: false;
            referencedRelation: 'orgs';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'project_contractors_partner_id_fkey';
            columns: ['partner_id'];
            isOneToOne: false;
            referencedRelation: 'partner_aliases';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'project_contractors_project_id_fkey';
            columns: ['project_id'];
            isOneToOne: false;
            referencedRelation: 'projects';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'project_contractors_subproject_client_view_id_fkey';
            columns: ['subproject_client_view_id'];
            isOneToOne: false;
            referencedRelation: 'projects';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'project_contractors_subproject_view_id_fkey';
            columns: ['subproject_view_id'];
            isOneToOne: false;
            referencedRelation: 'projects';
            referencedColumns: ['id'];
          },
        ];
      };
      project_documents: {
        Row: {
          association: string | null;
          created_at: string;
          creator_id: string;
          file_path: string;
          id: number;
          org_id: number;
          project_id: number;
          title: string;
          type: string | null;
          visibility: string;
        };
        Insert: {
          association?: string | null;
          created_at?: string;
          creator_id: string;
          file_path: string;
          id?: number;
          org_id: number;
          project_id: number;
          title: string;
          type?: string | null;
          visibility: string;
        };
        Update: {
          association?: string | null;
          created_at?: string;
          creator_id?: string;
          file_path?: string;
          id?: number;
          org_id?: number;
          project_id?: number;
          title?: string;
          type?: string | null;
          visibility?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'project_documents_org_id_fkey';
            columns: ['org_id'];
            isOneToOne: false;
            referencedRelation: 'orgs';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'project_documents_project_id_fkey';
            columns: ['project_id'];
            isOneToOne: false;
            referencedRelation: 'projects';
            referencedColumns: ['id'];
          },
        ];
      };
      project_kpis: {
        Row: {
          created_at: string;
          description: string | null;
          id: number;
          max_value: number | null;
          name: string;
          owner_org_id: number | null;
          project_id: number | null;
          type: string | null;
          unit: string | null;
        };
        Insert: {
          created_at?: string;
          description?: string | null;
          id?: number;
          max_value?: number | null;
          name: string;
          owner_org_id?: number | null;
          project_id?: number | null;
          type?: string | null;
          unit?: string | null;
        };
        Update: {
          created_at?: string;
          description?: string | null;
          id?: number;
          max_value?: number | null;
          name?: string;
          owner_org_id?: number | null;
          project_id?: number | null;
          type?: string | null;
          unit?: string | null;
        };
        Relationships: [
          {
            foreignKeyName: 'project_kpis_owner_org_id_fkey';
            columns: ['owner_org_id'];
            isOneToOne: false;
            referencedRelation: 'orgs';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'project_kpis_project_id_fkey';
            columns: ['project_id'];
            isOneToOne: false;
            referencedRelation: 'projects';
            referencedColumns: ['id'];
          },
        ];
      };
      project_member_invites: {
        Row: {
          created_at: string | null;
          created_by: string | null;
          deeplink_prefix: string | null;
          id: number;
          invitation_token: string | null;
          org_member_id: string;
          project_id: number;
          status: Database['public']['Enums']['invitation_status'] | null;
        };
        Insert: {
          created_at?: string | null;
          created_by?: string | null;
          deeplink_prefix?: string | null;
          id?: number;
          invitation_token?: string | null;
          org_member_id: string;
          project_id: number;
          status?: Database['public']['Enums']['invitation_status'] | null;
        };
        Update: {
          created_at?: string | null;
          created_by?: string | null;
          deeplink_prefix?: string | null;
          id?: number;
          invitation_token?: string | null;
          org_member_id?: string;
          project_id?: number;
          status?: Database['public']['Enums']['invitation_status'] | null;
        };
        Relationships: [
          {
            foreignKeyName: 'project_member_invites_org_member_id_fkey';
            columns: ['org_member_id'];
            isOneToOne: false;
            referencedRelation: 'org_members';
            referencedColumns: ['member_id'];
          },
          {
            foreignKeyName: 'project_member_invites_project_id_fkey';
            columns: ['project_id'];
            isOneToOne: false;
            referencedRelation: 'projects';
            referencedColumns: ['id'];
          },
        ];
      };
      project_members: {
        Row: {
          created_at: string | null;
          org_member_id: string;
          project_id: number;
        };
        Insert: {
          created_at?: string | null;
          org_member_id: string;
          project_id: number;
        };
        Update: {
          created_at?: string | null;
          org_member_id?: string;
          project_id?: number;
        };
        Relationships: [
          {
            foreignKeyName: 'project_members_org_member_id_fkey';
            columns: ['org_member_id'];
            isOneToOne: false;
            referencedRelation: 'org_members';
            referencedColumns: ['member_id'];
          },
          {
            foreignKeyName: 'project_members_project_id_fkey';
            columns: ['project_id'];
            isOneToOne: false;
            referencedRelation: 'projects';
            referencedColumns: ['id'];
          },
        ];
      };
      project_notes: {
        Row: {
          content: string;
          created_at: string;
          id: number;
          note_type: Database['public']['Enums']['note_type'];
          profile_id: string | null;
          project_id: number;
          updated_at: string;
        };
        Insert: {
          content?: string;
          created_at?: string;
          id?: number;
          note_type: Database['public']['Enums']['note_type'];
          profile_id?: string | null;
          project_id: number;
          updated_at?: string;
        };
        Update: {
          content?: string;
          created_at?: string;
          id?: number;
          note_type?: Database['public']['Enums']['note_type'];
          profile_id?: string | null;
          project_id?: number;
          updated_at?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'project_notes_profile_id_fkey';
            columns: ['profile_id'];
            isOneToOne: false;
            referencedRelation: 'profiles';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'project_notes_project_id_fkey';
            columns: ['project_id'];
            isOneToOne: false;
            referencedRelation: 'projects';
            referencedColumns: ['id'];
          },
        ];
      };
      project_ownership_transfer: {
        Row: {
          created_at: string | null;
          created_by: string | null;
          deeplink_prefix: string | null;
          id: string;
          invitation_token: string;
          inviter_profile_id: string | null;
          project_id: number;
          status: string | null;
          to_email: string;
        };
        Insert: {
          created_at?: string | null;
          created_by?: string | null;
          deeplink_prefix?: string | null;
          id?: string;
          invitation_token?: string;
          inviter_profile_id?: string | null;
          project_id: number;
          status?: string | null;
          to_email: string;
        };
        Update: {
          created_at?: string | null;
          created_by?: string | null;
          deeplink_prefix?: string | null;
          id?: string;
          invitation_token?: string;
          inviter_profile_id?: string | null;
          project_id?: number;
          status?: string | null;
          to_email?: string;
        };
        Relationships: [
          {
            foreignKeyName: 'project_ownership_transfer_inviter_profile_id_fkey';
            columns: ['inviter_profile_id'];
            isOneToOne: false;
            referencedRelation: 'profiles';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'project_ownership_transfer_project_id_fkey';
            columns: ['project_id'];
            isOneToOne: false;
            referencedRelation: 'projects';
            referencedColumns: ['id'];
          },
        ];
      };
      project_plan_entitlements: {
        Row: {
          derivative_kpis: number | null;
          plan_type: string;
          seats: number;
          standard_kpis: number | null;
          subprojects: number;
        };
        Insert: {
          derivative_kpis?: number | null;
          plan_type: string;
          seats: number;
          standard_kpis?: number | null;
          subprojects: number;
        };
        Update: {
          derivative_kpis?: number | null;
          plan_type?: string;
          seats?: number;
          standard_kpis?: number | null;
          subprojects?: number;
        };
        Relationships: [];
      };
      project_subscriptions: {
        Row: {
          billing_period: string;
          cancel_at: string | null;
          canceled_at: string | null;
          created_at: string | null;
          id: string;
          organization_id: number;
          plan_type: string;
          status: Database['public']['Enums']['stripe_status'];
          stripe_price_id: string | null;
          stripe_subscription_id: string | null;
          updated_at: string | null;
        };
        Insert: {
          billing_period: string;
          cancel_at?: string | null;
          canceled_at?: string | null;
          created_at?: string | null;
          id?: string;
          organization_id: number;
          plan_type: string;
          status?: Database['public']['Enums']['stripe_status'];
          stripe_price_id?: string | null;
          stripe_subscription_id?: string | null;
          updated_at?: string | null;
        };
        Update: {
          billing_period?: string;
          cancel_at?: string | null;
          canceled_at?: string | null;
          created_at?: string | null;
          id?: string;
          organization_id?: number;
          plan_type?: string;
          status?: Database['public']['Enums']['stripe_status'];
          stripe_price_id?: string | null;
          stripe_subscription_id?: string | null;
          updated_at?: string | null;
        };
        Relationships: [
          {
            foreignKeyName: 'project_subscriptions_organization_id_fkey';
            columns: ['organization_id'];
            isOneToOne: false;
            referencedRelation: 'orgs';
            referencedColumns: ['id'];
          },
        ];
      };
      projects: {
        Row: {
          category: string | null;
          client_contact: string | null;
          connected_project: number | null;
          contractor_contact: string | null;
          created_at: string;
          description: string | null;
          end_date: string | null;
          id: number;
          main_contact: string | null;
          name: string;
          org_id: number | null;
          ownership_status: string | null;
          parent_id: number | null;
          start_date: string | null;
          status: string | null;
          status_last_calculated_status: string | null;
          sub_category: string | null;
          subscription_id: string | null;
          tracking_interval: string | null;
          type: Database['public']['Enums']['project_type'];
        };
        Insert: {
          category?: string | null;
          client_contact?: string | null;
          connected_project?: number | null;
          contractor_contact?: string | null;
          created_at?: string;
          description?: string | null;
          end_date?: string | null;
          id?: number;
          main_contact?: string | null;
          name: string;
          org_id?: number | null;
          ownership_status?: string | null;
          parent_id?: number | null;
          start_date?: string | null;
          status?: string | null;
          status_last_calculated_status?: string | null;
          sub_category?: string | null;
          subscription_id?: string | null;
          tracking_interval?: string | null;
          type?: Database['public']['Enums']['project_type'];
        };
        Update: {
          category?: string | null;
          client_contact?: string | null;
          connected_project?: number | null;
          contractor_contact?: string | null;
          created_at?: string;
          description?: string | null;
          end_date?: string | null;
          id?: number;
          main_contact?: string | null;
          name?: string;
          org_id?: number | null;
          ownership_status?: string | null;
          parent_id?: number | null;
          start_date?: string | null;
          status?: string | null;
          status_last_calculated_status?: string | null;
          sub_category?: string | null;
          subscription_id?: string | null;
          tracking_interval?: string | null;
          type?: Database['public']['Enums']['project_type'];
        };
        Relationships: [
          {
            foreignKeyName: 'projects_connected_project_fkey';
            columns: ['connected_project'];
            isOneToOne: false;
            referencedRelation: 'projects';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'projects_org_id_fkey';
            columns: ['org_id'];
            isOneToOne: false;
            referencedRelation: 'orgs';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'projects_parent_id_fkey';
            columns: ['parent_id'];
            isOneToOne: false;
            referencedRelation: 'projects';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'projects_subscription_id_fkey';
            columns: ['subscription_id'];
            isOneToOne: true;
            referencedRelation: 'project_subscriptions';
            referencedColumns: ['id'];
          },
        ];
      };
      subproject_comment: {
        Row: {
          author_profile_id: string | null;
          created_at: string;
          id: number;
          message: string;
          seen: boolean;
          subproject_client_view_id: number | null;
          subproject_contractor_view_id: number | null;
          view_type: Database['public']['Enums']['project_type'];
        };
        Insert: {
          author_profile_id?: string | null;
          created_at?: string;
          id?: number;
          message?: string;
          seen?: boolean;
          subproject_client_view_id?: number | null;
          subproject_contractor_view_id?: number | null;
          view_type: Database['public']['Enums']['project_type'];
        };
        Update: {
          author_profile_id?: string | null;
          created_at?: string;
          id?: number;
          message?: string;
          seen?: boolean;
          subproject_client_view_id?: number | null;
          subproject_contractor_view_id?: number | null;
          view_type?: Database['public']['Enums']['project_type'];
        };
        Relationships: [
          {
            foreignKeyName: 'subproject_comment_author_profile_id_fkey';
            columns: ['author_profile_id'];
            isOneToOne: false;
            referencedRelation: 'profiles';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'subproject_comment_subproject_client_id_fkey';
            columns: ['subproject_client_view_id'];
            isOneToOne: false;
            referencedRelation: 'projects';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'subproject_comment_subproject_contractor_id_fkey';
            columns: ['subproject_contractor_view_id'];
            isOneToOne: false;
            referencedRelation: 'projects';
            referencedColumns: ['id'];
          },
        ];
      };
      subproject_view_budget: {
        Row: {
          budget: number | null;
          created_at: string | null;
          id: string;
          kpi_id: number | null;
          subproject_view_id: number | null;
        };
        Insert: {
          budget?: number | null;
          created_at?: string | null;
          id?: string;
          kpi_id?: number | null;
          subproject_view_id?: number | null;
        };
        Update: {
          budget?: number | null;
          created_at?: string | null;
          id?: string;
          kpi_id?: number | null;
          subproject_view_id?: number | null;
        };
        Relationships: [
          {
            foreignKeyName: 'contractor_view_budget_kpi_id_fkey';
            columns: ['kpi_id'];
            isOneToOne: false;
            referencedRelation: 'project_kpis';
            referencedColumns: ['id'];
          },
          {
            foreignKeyName: 'contractor_view_budget_subproject_contractor_view_id_fkey';
            columns: ['subproject_view_id'];
            isOneToOne: false;
            referencedRelation: 'projects';
            referencedColumns: ['id'];
          },
        ];
      };
      subscription_addons: {
        Row: {
          addon_type: string;
          billing_period: string;
          cancel_at: string | null;
          canceled_at: string | null;
          created_at: string | null;
          id: string;
          organization_id: number;
          quantity: number;
          status: Database['public']['Enums']['stripe_status'];
          stripe_price_id: string | null;
          stripe_subscription_id: string | null;
          updated_at: string | null;
        };
        Insert: {
          addon_type: string;
          billing_period: string;
          cancel_at?: string | null;
          canceled_at?: string | null;
          created_at?: string | null;
          id?: string;
          organization_id: number;
          quantity?: number;
          status?: Database['public']['Enums']['stripe_status'];
          stripe_price_id?: string | null;
          stripe_subscription_id?: string | null;
          updated_at?: string | null;
        };
        Update: {
          addon_type?: string;
          billing_period?: string;
          cancel_at?: string | null;
          canceled_at?: string | null;
          created_at?: string | null;
          id?: string;
          organization_id?: number;
          quantity?: number;
          status?: Database['public']['Enums']['stripe_status'];
          stripe_price_id?: string | null;
          stripe_subscription_id?: string | null;
          updated_at?: string | null;
        };
        Relationships: [
          {
            foreignKeyName: 'subscription_addons_organization_id_fkey';
            columns: ['organization_id'];
            isOneToOne: false;
            referencedRelation: 'orgs';
            referencedColumns: ['id'];
          },
        ];
      };
      subscription_events: {
        Row: {
          created_at: string | null;
          event_type: string;
          id: string;
          metadata: Json | null;
          new_status: string | null;
          old_status: string | null;
          organization_id: number | null;
          stripe_event_id: string | null;
          stripe_event_type: string | null;
        };
        Insert: {
          created_at?: string | null;
          event_type: string;
          id?: string;
          metadata?: Json | null;
          new_status?: string | null;
          old_status?: string | null;
          organization_id?: number | null;
          stripe_event_id?: string | null;
          stripe_event_type?: string | null;
        };
        Update: {
          created_at?: string | null;
          event_type?: string;
          id?: string;
          metadata?: Json | null;
          new_status?: string | null;
          old_status?: string | null;
          organization_id?: number | null;
          stripe_event_id?: string | null;
          stripe_event_type?: string | null;
        };
        Relationships: [
          {
            foreignKeyName: 'subscription_events_organization_id_fkey';
            columns: ['organization_id'];
            isOneToOne: false;
            referencedRelation: 'orgs';
            referencedColumns: ['id'];
          },
        ];
      };
    };
    Views: {
      derivative_kpi_metrics_view: {
        Row: {
          current_month_value: number | null;
          current_year_value: number | null;
          id: number | null;
          last_entry_date: string | null;
          last_entry_ratio: number | null;
          latest_entry_value: number | null;
          monthly_total_to_current_month_ratio: number | null;
          previous_month_value: number | null;
          previous_year_value: number | null;
          project_id: number | null;
          second_latest_entry_value: number | null;
          total_value: number | null;
          yearly_total_to_previous_year_ratio: number | null;
        };
        Relationships: [];
      };
      kpi_metrics_view: {
        Row: {
          aggregated_latest_value: number | null;
          aggregated_previous_value: number | null;
          created_at: string | null;
          id: number | null;
          last_entry_date: string | null;
          last_entry_ratio: number | null;
          latest_entry_value: number | null;
          project_id: number | null;
          second_latest_entry_value: number | null;
          subproject_count: number | null;
          sum_current_month: number | null;
          sum_current_year: number | null;
          sum_previous_month: number | null;
          sum_previous_year: number | null;
        };
        Relationships: [];
      };
    };
    Functions: {
      accept_subproject_invitation: {
        Args: { p_invitation_token: string; p_view_json: Json };
        Returns: number;
      };
      appoint_kpi: { Args: { p_kpi_assignments: Json }; Returns: undefined };
      are_users_partners: {
        Args: { user_a: string; user_b: string };
        Returns: boolean;
      };
      assign_addon_to_project: {
        Args: { p_addon_id: string; p_project_id: number };
        Returns: string;
      };
      assign_project_plan: {
        Args: { p_project_id: number; p_subscription_id: string };
        Returns: boolean;
      };
      build_report_with_data:
        | {
            Args: {
              p_created_by_id: string;
              p_created_by_name: string;
              p_project_id: number;
              p_project_name: string;
              p_report: Database['public']['Tables']['kpi_tracking_reports']['Row'];
            };
            Returns: Json;
          }
        | {
            Args: {
              p_creator_entity_name: string;
              p_project_id: number;
              p_project_name: string;
              p_report: Database['public']['Tables']['kpi_tracking_reports']['Row'];
            };
            Returns: Json;
          };
      calculate_automated_project_status: {
        Args: { p_end_date: string; p_start_date: string };
        Returns: string;
      };
      can_delete_user: { Args: { p_user_id: string }; Returns: boolean };
      cancel_project_ownership_transfer: {
        Args: { p_transfer_id: string };
        Returns: boolean;
      };
      check_can_access_ai_feature: {
        Args: { p_org_id: number };
        Returns: undefined;
      };
      check_storage_limit: {
        Args: { p_file_size: number; p_org_id: number };
        Returns: undefined;
      };
      check_tracking_overdue_notifications: {
        Args: { p_interval?: string };
        Returns: undefined;
      };
      claim_project_ownership: {
        Args: { p_invitation_token: string; p_org_id: number };
        Returns: number;
      };
      count_partner_active_projects:
        | { Args: { p_partner_orga_id: number }; Returns: number }
        | {
            Args: { p_owner_orga_id: number; p_partner_orga_id: number };
            Returns: number;
          };
      create_chart_config: {
        Args: {
          p_aggregation_type: string;
          p_chart_type: string;
          p_config_type: string;
          p_created_by: string;
          p_creator_orga_id: number;
          p_is_derivative: boolean;
          p_kpi_ids: number[];
          p_project_id: number;
        };
        Returns: undefined;
      };
      create_chart_with_kpis: {
        Args: {
          p_aggregation_type: string;
          p_chart_type: string;
          p_config_type: string;
          p_created_by: string;
          p_creator_orga_id: number;
          p_kpi_ids: number[];
          p_project_id: number;
        };
        Returns: undefined;
      };
      create_client_subproject_kpi: {
        Args: {
          p_max_value?: number;
          p_name: string;
          p_project_id: number;
          p_tracking_type: string;
          p_unit: string;
        };
        Returns: undefined;
      };
      create_internal_subproject: {
        Args: {
          p_alias: string;
          p_kpis: Json;
          p_project_id: number;
          p_subproject_client_view: Json;
        };
        Returns: number;
      };
      create_org: {
        Args: {
          org_category?: string;
          org_name: string;
          org_sub_category?: string;
        };
        Returns: {
          category_id: string | null;
          created_at: string;
          created_by: string | null;
          id: number;
          image_url: string | null;
          name: string | null;
          self_orga_user_id: string | null;
          subcategory_id: string | null;
        };
        SetofOptions: {
          from: '*';
          to: 'orgs';
          isOneToOne: true;
          isSetofReturn: false;
        };
      };
      create_project: { Args: { body: Json }; Returns: number };
      create_project_contractor: {
        Args: {
          p_partner_id: string;
          p_project_id: number;
          p_subproject_client_view_id: number;
          p_subproject_contractor_view_id: number;
        };
        Returns: undefined;
      };
      create_subproject_for_existing_partner: {
        Args: {
          p_deeplink_prefix: string;
          p_kpis: Json;
          p_partner_id: string;
          p_project_id: number;
          p_subproject_client_view: Json;
        };
        Returns: number;
      };
      create_subproject_for_new_partner: {
        Args: {
          p_alias: string;
          p_deeplink_prefix: string;
          p_kpis: Json;
          p_project_id: number;
          p_subproject_client_view: Json;
          p_to_email: string;
        };
        Returns: number;
      };
      create_tracking_report: {
        Args: {
          p_description: string;
          p_document_ids: number[];
          p_kpi_entries: Json;
          p_project_id: number;
        };
        Returns: number;
      };
      create_tracking_report_invoker: {
        Args: {
          p_created_by: string;
          p_created_by_token: number;
          p_description: string;
          p_document_ids: number[];
          p_kpi_entries: Json;
          p_project_id: number;
        };
        Returns: number;
      };
      delete_assigned_kpi: {
        Args: { p_budget_id: string };
        Returns: undefined;
      };
      delete_org_integration_token: {
        Args: { p_org_id: number; p_token_id: number };
        Returns: number;
      };
      delete_org_integration_token_invoker: {
        Args: { p_token_id: number; p_user_id: string };
        Returns: number;
      };
      detect_kpi_anomalies: {
        Args: {
          p_from_date?: string;
          p_kpi_id: number;
          p_months_back?: number;
          p_period_type?: Database['public']['Enums']['period_type'];
          p_project_id: number;
          p_to_date?: string;
        };
        Returns: {
          aggregated_value: number;
          deviation_percentage: number;
          forecast_value: number;
          is_anomaly: boolean;
          lower_bound: number;
          org_name: string;
          org_picture_url: string;
          period: string;
          period_end: string;
          period_start: string;
          period_type: Database['public']['Enums']['period_type'];
          project_name: string;
          upper_bound: number;
        }[];
      };
      do_users_have_shared_org: {
        Args: { user_a: string; user_b: string };
        Returns: boolean;
      };
      extract_avatar_profile_id: { Args: { name: string }; Returns: string };
      extract_creator_id: { Args: { name: string }; Returns: string };
      extract_org_id: { Args: { name: string }; Returns: number };
      extract_org_id_from_avatar_path: {
        Args: { name: string };
        Returns: number;
      };
      extract_project_id: { Args: { name: string }; Returns: number };
      extract_visibility: { Args: { name: string }; Returns: string };
      format_period_end: {
        Args: {
          p_period: string;
          p_period_type: Database['public']['Enums']['period_type'];
        };
        Returns: string;
      };
      format_period_start: {
        Args: {
          p_period: string;
          p_period_type: Database['public']['Enums']['period_type'];
        };
        Returns: string;
      };
      generate_org_integration_token: {
        Args: { p_org_id: number; p_project_id: number; p_token_name: string };
        Returns: Json;
      };
      generate_org_integration_token_invoker: {
        Args: {
          p_creator_id: string;
          p_org_id: number;
          p_project_id: number;
          p_token_name: string;
        };
        Returns: Json;
      };
      get_addon_subscriptions: {
        Args: { p_organization_id: number };
        Returns: Database['public']['CompositeTypes']['addon_subscription_with_available'];
        SetofOptions: {
          from: '*';
          to: 'addon_subscription_with_available';
          isOneToOne: true;
          isSetofReturn: false;
        };
      };
      get_available_project_subscriptions: {
        Args: { p_organization_id: number };
        Returns: {
          billing_period: string;
          cancel_at: string | null;
          canceled_at: string | null;
          created_at: string | null;
          id: string;
          organization_id: number;
          plan_type: string;
          status: Database['public']['Enums']['stripe_status'];
          stripe_price_id: string | null;
          stripe_subscription_id: string | null;
          updated_at: string | null;
        }[];
        SetofOptions: {
          from: '*';
          to: 'project_subscriptions';
          isOneToOne: false;
          isSetofReturn: true;
        };
      };
      get_client_partner_by_contractor_project: {
        Args: { p_project_id: number };
        Returns: {
          alias: string;
          created_at: string | null;
          created_by: string | null;
          id: string;
          invited_email: string | null;
          owner_orga_id: number;
          partner_orga_id: number | null;
          updated_at: string | null;
          updated_by: string | null;
        };
        SetofOptions: {
          from: '*';
          to: 'partner_aliases';
          isOneToOne: true;
          isSetofReturn: false;
        };
      };
      get_contractor_project_alias:
        | { Args: { p_contractor_project_id: number }; Returns: string }
        | {
            Args: { p_owner_orga_id: number; p_partner_orga_id: number };
            Returns: string;
          };
      get_contractor_project_parent_name: {
        Args: { p_project_id: number };
        Returns: string;
      };
      get_created_tracking_report_count_for_token_in_last_hour: {
        Args: { p_token_id: number };
        Returns: number;
      };
      get_derivative_kpi_historical_data: {
        Args: { p_kpi_id: number; p_project_id: number };
        Returns: {
          timestamp_: string;
          value: number;
        }[];
      };
      get_documents: {
        Args: {
          p_file_type?: string;
          p_from_date?: string;
          p_organization_id?: number;
          p_partner_ids?: string[];
          p_project_id?: number;
          p_project_ids?: number[];
          p_roles?: string[];
          p_search_query?: string;
          p_to_date?: string;
          p_uploaded_by?: string[];
          p_visibilities?: string[];
        };
        Returns: {
          association: string;
          client_org_name: string;
          created_at: string;
          creator: Json;
          file_path: string;
          id: number;
          org_id: number;
          partner_names: string;
          project_id: number;
          project_name: string;
          project_type: string;
          role: string;
          sub_project_names: string;
          title: string;
          type: string;
          uploaded_by_org: string;
          visibility: string;
          write_access: boolean;
        }[];
      };
      get_documents_for_report: {
        Args: { p_report_id: number };
        Returns: Json;
      };
      get_filtered_insights_projects: {
        Args: {
          p_date_from?: string;
          p_date_to?: string;
          p_org_id: number;
          p_project_ids?: number[];
          p_subproject_ids?: number[];
        };
        Returns: Json[];
      };
      get_filtered_org_partners: {
        Args: {
          p_date_from?: string;
          p_date_to?: string;
          p_owner_orga_id: number;
          p_partner_ids?: string[];
          p_roles?: string[];
          p_search_query?: string;
        };
        Returns: {
          active_projects: number;
          orga: Database['public']['CompositeTypes']['org_public'];
          partner_alias: Database['public']['Tables']['partner_aliases']['Row'];
          partner_role: string;
          partner_status: string;
        }[];
      };
      get_filtered_org_projects: {
        Args: {
          p_date_from?: string;
          p_date_to?: string;
          p_last_entry_types?: string[];
          p_notification_types?: string[];
          p_org_id: number;
          p_partners_ids?: string[];
          p_roles?: string[];
          p_search_query?: string;
          p_statuses?: string[];
        };
        Returns: Json[];
      };
      get_filtered_project_subprojects: {
        Args: {
          p_date_from?: string;
          p_date_to?: string;
          p_last_entry_types?: string[];
          p_notification_types?: string[];
          p_partners_ids?: string[];
          p_project_id: number;
          p_search_query?: string;
          p_statuses?: string[];
        };
        Returns: Json[];
      };
      get_kpi_accumulated_latest_value: {
        Args: { p_kpi_id: number; p_project_id: number };
        Returns: {
          aggregated_value: number;
          last_entry_date: string;
          subproject_count: number;
        }[];
      };
      get_kpi_historical_data: {
        Args: { p_kpi_id: number; p_project_id: number };
        Returns: {
          timestamp_: string;
          value: number;
        }[];
      };
      get_kpi_timeline_aggregated_values: {
        Args: {
          p_from_date?: string;
          p_kpi_id: number;
          p_period?: string;
          p_project_id: number;
          p_to_date?: string;
        };
        Returns: {
          aggregated_value: number;
          period_start: string;
          subproject_count: number;
        }[];
      };
      get_kpi_with_limited_entries: {
        Args: {
          p_from_date?: string;
          p_kpi_id: number;
          p_months_back?: number;
          p_project_id: number;
          p_to_date?: string;
        };
        Returns: Json;
      };
      get_notification_access_level: {
        Args: { p_content_type: string };
        Returns: string;
      };
      get_notifications: {
        Args: {
          p_content_categories?: string[];
          p_date_from?: string;
          p_date_to?: string;
          p_notification_statuses?: string[];
          p_notification_types?: string[];
          p_org_id: number;
          p_partners_ids?: string[];
          p_project_ids?: number[];
          p_project_roles?: string[];
          p_subproject_ids?: number[];
        };
        Returns: {
          content_category: string;
          content_type: string;
          created_at: string;
          id: number;
          is_read: boolean;
          metadata: Json;
          org_id: number;
          type: string;
          user_id: string;
        }[];
      };
      get_org_integration_tokens: {
        Args: {
          p_is_inactive: boolean;
          p_org_id: number;
          p_project_id?: number;
        };
        Returns: Database['public']['CompositeTypes']['integration_token_result'][];
        SetofOptions: {
          from: '*';
          to: 'integration_token_result';
          isOneToOne: false;
          isSetofReturn: true;
        };
      };
      get_org_integration_tokens_invoker: {
        Args: {
          p_is_inactive: boolean;
          p_org_id: number;
          p_project_id?: number;
        };
        Returns: Database['public']['CompositeTypes']['integration_token_result'][];
        SetofOptions: {
          from: '*';
          to: 'integration_token_result';
          isOneToOne: false;
          isSetofReturn: true;
        };
      };
      get_org_subscription: {
        Args: { p_organization_id: number };
        Returns: Database['public']['CompositeTypes']['org_subscription_with_entitlements'];
        SetofOptions: {
          from: '*';
          to: 'org_subscription_with_entitlements';
          isOneToOne: true;
          isSetofReturn: false;
        };
      };
      get_org_subscription_invoker: {
        Args: { p_organization_id: number };
        Returns: Database['public']['CompositeTypes']['org_subscription_with_entitlements'];
        SetofOptions: {
          from: '*';
          to: 'org_subscription_with_entitlements';
          isOneToOne: true;
          isSetofReturn: false;
        };
      };
      get_partner_role_for_alias: {
        Args: { p_partner_alias_id: string };
        Returns: string;
      };
      get_partner_status: {
        Args: { p_owner_orga_id: number; p_partner_orga_id: number };
        Returns: string;
      };
      get_partners: {
        Args: { p_owner_orga_id: number };
        Returns: {
          active_projects: number;
          orga: Database['public']['CompositeTypes']['org_public'];
          partner_alias: Database['public']['Tables']['partner_aliases']['Row'];
          partner_status: string;
        }[];
      };
      get_profile_id: {
        Args: { p_org_id: number; p_user_id: string };
        Returns: string;
      };
      get_project_entitlements: {
        Args: { p_project_id: number };
        Returns: Database['public']['CompositeTypes']['project_subscription_with_entitlements_and_usage'];
        SetofOptions: {
          from: '*';
          to: 'project_subscription_with_entitlements_and_usage';
          isOneToOne: true;
          isSetofReturn: false;
        };
      };
      get_project_entitlements_invoker: {
        Args: { p_project_id: number };
        Returns: Database['public']['CompositeTypes']['project_subscription_with_entitlements_and_usage'];
        SetofOptions: {
          from: '*';
          to: 'project_subscription_with_entitlements_and_usage';
          isOneToOne: true;
          isSetofReturn: false;
        };
      };
      get_project_kpis: {
        Args: {
          p_change_type?: string;
          p_limit?: number;
          p_offset?: number;
          p_project_id: number;
        };
        Returns: {
          change_rate: number;
          created_at: string;
          current_sum: number;
          description: string;
          id: number;
          last_entry_date: string;
          latest_entry_value: number;
          max_value: number;
          name: string;
          owner_org_id: number;
          period_sum: number;
          project_id: number;
          second_latest_entry_value: number;
          type: string;
          unit: string;
        }[];
      };
      get_project_notification_recipients: {
        Args: { p_project_id: number };
        Returns: {
          email: string;
          language: string;
          name: string;
          user_id: string;
        }[];
      };
      get_project_org: {
        Args: { p_project_id: number };
        Returns: {
          category_id: string | null;
          created_at: string;
          created_by: string | null;
          id: number;
          image_url: string | null;
          name: string | null;
          self_orga_user_id: string | null;
          subcategory_id: string | null;
        };
        SetofOptions: {
          from: '*';
          to: 'orgs';
          isOneToOne: true;
          isSetofReturn: false;
        };
      };
      get_project_org_id: { Args: { p_project_id: number }; Returns: number };
      get_project_org_ids_batch: {
        Args: { p_project_ids: number[] };
        Returns: {
          org_id: number;
          project_id: number;
        }[];
      };
      get_project_ownership_transfer: {
        Args: { p_project_id: number };
        Returns: {
          created_at: string;
          id: string;
          invitation_token: string;
          project_id: number;
          status: string;
          to_email: string;
        }[];
      };
      get_project_ownership_transfer_by_token: {
        Args: { p_invitation_token: string };
        Returns: {
          id: string;
          inviter_email: string;
          inviter_name: string;
          project_id: number;
          project_name: string;
          status: string;
          to_email: string;
        }[];
      };
      get_project_partner_id: {
        Args: { p_project_id: number };
        Returns: string;
      };
      get_project_permissions: {
        Args: { p_project_id: number };
        Returns: Database['public']['CompositeTypes']['project_usage_permissions'];
        SetofOptions: {
          from: '*';
          to: 'project_usage_permissions';
          isOneToOne: true;
          isSetofReturn: false;
        };
      };
      get_project_plan_usage_counts: {
        Args: { p_organization_id: number };
        Returns: Database['public']['CompositeTypes']['project_plan_usage_counts'];
        SetofOptions: {
          from: '*';
          to: 'project_plan_usage_counts';
          isOneToOne: true;
          isSetofReturn: false;
        };
      };
      get_reporting_period_boundaries: {
        Args: { p_interval: string };
        Returns: {
          period_end: string;
          period_start: string;
        }[];
      };
      get_reports_for_client: {
        Args: {
          p_limit?: number;
          p_months_back?: number;
          p_offset?: number;
          p_project_id: number;
        };
        Returns: Json;
      };
      get_reports_for_contractor: {
        Args: {
          p_limit?: number;
          p_months_back?: number;
          p_offset?: number;
          p_project_id: number;
        };
        Returns: Json;
      };
      get_storage_usage: {
        Args: { p_organization_id: number };
        Returns: number;
      };
      get_subproject_kpis: {
        Args: { p_project_id: number };
        Returns: {
          budget: number;
          budget_id: string;
          metrics: Database['public']['Views']['kpi_metrics_view']['Row'];
          project_kpis: Database['public']['Tables']['project_kpis']['Row'];
        }[];
      };
      get_tracking_entries_for_report: {
        Args: { p_report_id: number };
        Returns: Json;
      };
      get_tracking_reports: {
        Args: {
          p_limit?: number;
          p_months_back?: number;
          p_offset?: number;
          p_project_id: number;
        };
        Returns: Json;
      };
      get_user_id_from_profile_id: {
        Args: { p_profile_id: string };
        Returns: string;
      };
      get_user_orgs: {
        Args: never;
        Returns: {
          category_id: string | null;
          created_at: string;
          created_by: string | null;
          id: number;
          image_url: string | null;
          name: string | null;
          self_orga_user_id: string | null;
          subcategory_id: string | null;
        }[];
        SetofOptions: {
          from: '*';
          to: 'orgs';
          isOneToOne: false;
          isSetofReturn: true;
        };
      };
      get_user_projects_with_member_count: { Args: never; Returns: Json[] };
      has_chart_config_kpi_access: {
        Args: { p_chart_config_id: number };
        Returns: boolean;
      };
      has_document_access: {
        Args: {
          p_document_creator_id: string;
          p_document_org_id: number;
          p_document_project_id: number;
          p_document_visibility: string;
        };
        Returns: boolean;
      };
      has_document_write_access: {
        Args: {
          p_creator_id: string;
          p_org_id: number;
          p_project_id: number;
          p_visibility: string;
        };
        Returns: boolean;
      };
      has_org_access: {
        Args: {
          p_allowed_roles?: string[];
          p_org_id: number;
          p_user_id?: string;
        };
        Returns: boolean;
      };
      has_overdue_tracking: {
        Args: {
          p_kpi_id: number;
          p_period_end: string;
          p_period_start: string;
          p_project_id: number;
        };
        Returns: boolean;
      };
      has_pending_org_invite: { Args: { p_org_id: number }; Returns: boolean };
      has_project_access:
        | { Args: { p_project_id: number }; Returns: boolean }
        | {
            Args: { p_org_id: number; p_project_id: number };
            Returns: boolean;
          };
      has_project_invite_access: {
        Args: { p_org_member_id: string };
        Returns: boolean;
      };
      has_project_member_invites_write_access: {
        Args: { p_member_id: string; p_project_id: number };
        Returns: boolean;
      };
      has_subproject_client_view_access: {
        Args: { p_subproject_client_view_id: number };
        Returns: boolean;
      };
      has_worked_with_partner: {
        Args: { p_partner_orga_id: number; p_profile_id: string };
        Returns: boolean;
      };
      initiate_project_ownership_transfer: {
        Args: {
          p_deeplink_prefix: string;
          p_project_id: number;
          p_to_email: string;
        };
        Returns: string;
      };
      invite_existing_contractor_to_subproject: {
        Args: {
          p_deeplink_prefix: string;
          p_partner_id: string;
          p_subproject_client_view_id: number;
        };
        Returns: string;
      };
      invite_new_contractor_to_subproject: {
        Args: {
          p_alias: string;
          p_deeplink_prefix: string;
          p_email: string;
          p_subproject_client_view_id: number;
        };
        Returns: string;
      };
      is_array_null_or_empty: { Args: { arr: unknown }; Returns: boolean };
      is_client_of_project: {
        Args: { p_project_id: number };
        Returns: boolean;
      };
      is_contractor_of_project: {
        Args: { p_project_id: number };
        Returns: boolean;
      };
      is_direct_parent_of: {
        Args: { p_parent_project_id: number; p_project_id: number };
        Returns: boolean;
      };
      is_invited_to_project: {
        Args: { p_project_id: number };
        Returns: boolean;
      };
      is_notification_read: {
        Args: { p_notification_id: number };
        Returns: boolean;
      };
      is_parent_of: {
        Args: { p_parent_project_id: number; p_project_id: number };
        Returns: boolean;
      };
      is_partner_org: { Args: { p_target_org_id: number }; Returns: boolean };
      kpi_metrics: {
        Args: { pk: Database['public']['Tables']['project_kpis']['Row'] };
        Returns: {
          aggregated_latest_value: number | null;
          aggregated_previous_value: number | null;
          created_at: string | null;
          id: number | null;
          last_entry_date: string | null;
          last_entry_ratio: number | null;
          latest_entry_value: number | null;
          project_id: number | null;
          second_latest_entry_value: number | null;
          subproject_count: number | null;
          sum_current_month: number | null;
          sum_current_year: number | null;
          sum_previous_month: number | null;
          sum_previous_year: number | null;
        };
        SetofOptions: {
          from: 'project_kpis';
          to: 'kpi_metrics_view';
          isOneToOne: true;
          isSetofReturn: true;
        };
      };
      manage_org_invitation: {
        Args: {
          p_invitation_status: Database['public']['Enums']['invitation_status'];
          p_invitation_token: string;
        };
        Returns: Json;
      };
      manage_project_invitation: {
        Args: {
          p_invitation_status: Database['public']['Enums']['invitation_status'];
          p_invitation_token: string;
        };
        Returns: boolean;
      };
      manual_update_project_status: {
        Args: { p_project_id: number; p_status: string };
        Returns: undefined;
      };
      mark_notifications_as_read: {
        Args: { p_notification_ids: number[] };
        Returns: undefined;
      };
      matches_created_between: {
        Args: { p_created_at: string; p_date_from: string; p_date_to: string };
        Returns: boolean;
      };
      matches_last_entry_types: {
        Args: { p_last_entry_types: string[]; p_project_id: number };
        Returns: boolean;
      };
      matches_notification_types: {
        Args: {
          p_notification_id: number;
          p_notification_types: string[];
          p_read_at: string;
        };
        Returns: boolean;
      };
      matches_partners: {
        Args: { p_partner_id: string; p_partners_ids: string[] };
        Returns: boolean;
      };
      matches_project_date_range: {
        Args: {
          p_date_from: string;
          p_date_to: string;
          p_end_date: string;
          p_start_date: string;
        };
        Returns: boolean;
      };
      matches_roles: {
        Args: {
          p_roles: string[];
          p_type: Database['public']['Enums']['project_type'];
        };
        Returns: boolean;
      };
      matches_search: {
        Args: { p_name: string; p_search_query: string };
        Returns: boolean;
      };
      matches_status: {
        Args: { p_status: string; p_statuses: string[] };
        Returns: boolean;
      };
      member_user_id: { Args: { p_member_id: string }; Returns: string };
      org_has_integrations_entitlement: {
        Args: { p_org_id: number };
        Returns: boolean;
      };
      org_id_of_member: { Args: { p_member_id: string }; Returns: number };
      project_belongs_to_org: {
        Args: { p_org_id: number; p_project_id: number };
        Returns: boolean;
      };
      project_deadline_exceeded_notification: {
        Args: never;
        Returns: undefined;
      };
      project_end_hint_notification: { Args: never; Returns: undefined };
      project_has_overdue_tracking: {
        Args: { p_project_id: number };
        Returns: boolean;
      };
      remove_org_member: {
        Args: { p_member_id: string; p_org_id: number };
        Returns: undefined;
      };
      request_tracking: {
        Args: { p_client_project_id: number };
        Returns: undefined;
      };
      resend_org_member_invitation: {
        Args: { p_invitation_id: number };
        Returns: number;
      };
      resend_partner_invitation: {
        Args: { p_invitation_id: string };
        Returns: string;
      };
      resend_project_member_invitation: {
        Args: { p_invitation_id: number };
        Returns: number;
      };
      resend_project_ownership_transfer_email: {
        Args: { p_deeplink_prefix: string; p_transfer_id: string };
        Returns: string;
      };
      run_project_status_automation: { Args: never; Returns: string };
      search_org_member_management: {
        Args: {
          p_org_id: number;
          p_project_ids?: number[];
          p_query?: string;
          p_roles?: string[];
          p_statuses?: Database['public']['Enums']['invitation_status'][];
        };
        Returns: {
          email: string;
          entity_type: string;
          id: string;
          invitation: Json;
          invitation_status: Database['public']['Enums']['invitation_status'];
          member: Json;
          member_since: string;
          name: string;
          projects: string;
          role: string;
        }[];
      };
      search_project_member_management: {
        Args: { p_project_id: number; p_query?: string };
        Returns: {
          email: string;
          entity_type: string;
          id: string;
          invitation: Json;
          invitation_status: Database['public']['Enums']['invitation_status'];
          member_since: string;
          name: string;
          org_member: Json;
          project_member: Json;
          role: string;
        }[];
      };
      set_comment_seen: { Args: { p_comment_id: number }; Returns: undefined };
      sync_subproject_contractor_status: { Args: never; Returns: undefined };
      trigger_project_status_automation_now: { Args: never; Returns: string };
      update_chart_config: {
        Args: {
          p_aggregation_type: string;
          p_chart_id: number;
          p_chart_type: string;
          p_config_type: string;
          p_kpi_ids: number[];
        };
        Returns: undefined;
      };
      update_org_role: {
        Args: { p_member_id: string; p_role: string };
        Returns: undefined;
      };
      update_project_ownership_transfer_email: {
        Args: {
          p_deeplink_prefix: string;
          p_new_email: string;
          p_transfer_id: string;
        };
        Returns: string;
      };
      update_project_status_automation: { Args: never; Returns: undefined };
      update_tracking_report: {
        Args: {
          p_description: string;
          p_document_ids?: number[];
          p_kpi_entries: Json;
          p_report_id: number;
        };
        Returns: number;
      };
      upsert_team_note: {
        Args: { p_content: string; p_project_id: number };
        Returns: undefined;
      };
    };
    Enums: {
      invitation_status: 'pending' | 'accepted' | 'declined' | 'cancelled';
      language: 'de' | 'en';
      math_operation: 'add' | 'subtract' | 'multiply' | 'divide';
      note_type: 'team' | 'private';
      notification_content_category:
        | 'member_management'
        | 'project_information'
        | 'budget'
        | 'alert'
        | 'anomaly'
        | 'tracking';
      period_type: 'monthly' | 'quarterly' | 'yearly';
      project_type: 'project' | 'subproject_client' | 'subproject_contractor';
      stripe_status:
        | 'active'
        | 'past_due'
        | 'canceled'
        | 'incomplete'
        | 'incomplete_expired'
        | 'trialing'
        | 'unpaid';
    };
    CompositeTypes: {
      addon_subscription_with_available: {
        addons:
          | Database['public']['Tables']['subscription_addons']['Row'][]
          | null;
        seats_available: number | null;
        subprojects_available: number | null;
        derivative_kpis_available: number | null;
      };
      integration_token_result: {
        id: number | null;
        type: string | null;
        title: string | null;
        created_at: string | null;
        expires_at: string | null;
        last_used_at: string | null;
        status: string | null;
        organization_id: number | null;
      };
      org_public: {
        id: number | null;
        name: string | null;
        image_url: string | null;
        category_id: string | null;
        subcategory_id: string | null;
        created_at: string | null;
      };
      org_subscription_with_entitlements: {
        subscription:
          | Database['public']['Tables']['organization_subscriptions']['Row']
          | null;
        entitlements:
          | Database['public']['Tables']['org_plan_entitlements']['Row']
          | null;
      };
      project_plan_usage_counts: {
        client_core_available: number | null;
        client_core_used: number | null;
        client_growth_available: number | null;
        client_growth_used: number | null;
        client_scale_available: number | null;
        client_scale_used: number | null;
      };
      project_subscription_with_entitlements: {
        subscription:
          | Database['public']['Tables']['project_subscriptions']['Row']
          | null;
        entitlements:
          | Database['public']['Tables']['project_plan_entitlements']['Row']
          | null;
      };
      project_subscription_with_entitlements_and_usage: {
        subscription:
          | Database['public']['Tables']['project_subscriptions']['Row']
          | null;
        entitlements:
          | Database['public']['Tables']['project_plan_entitlements']['Row']
          | null;
        usage:
          | Database['public']['Tables']['project_plan_entitlements']['Row']
          | null;
        usage_permissions:
          | Database['public']['CompositeTypes']['project_usage_permissions']
          | null;
      };
      project_usage_permissions: {
        can_add_seat: boolean | null;
        can_add_subproject: boolean | null;
        can_add_standard_kpi: boolean | null;
        can_add_derivative_kpi: boolean | null;
      };
    };
  };
};

type DatabaseWithoutInternals = Omit<Database, '__InternalSupabase'>;

type DefaultSchema = DatabaseWithoutInternals[Extract<
  keyof Database,
  'public'
>];

export type Tables<
  DefaultSchemaTableNameOrOptions extends
    | keyof (DefaultSchema['Tables'] & DefaultSchema['Views'])
    | { schema: keyof DatabaseWithoutInternals },
  TableName extends DefaultSchemaTableNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals;
  }
    ? keyof (DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions['schema']]['Tables'] &
        DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions['schema']]['Views'])
    : never = never,
> = DefaultSchemaTableNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals;
}
  ? (DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions['schema']]['Tables'] &
      DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions['schema']]['Views'])[TableName] extends {
      Row: infer R;
    }
    ? R
    : never
  : DefaultSchemaTableNameOrOptions extends keyof (DefaultSchema['Tables'] &
        DefaultSchema['Views'])
    ? (DefaultSchema['Tables'] &
        DefaultSchema['Views'])[DefaultSchemaTableNameOrOptions] extends {
        Row: infer R;
      }
      ? R
      : never
    : never;

export type TablesInsert<
  DefaultSchemaTableNameOrOptions extends
    | keyof DefaultSchema['Tables']
    | { schema: keyof DatabaseWithoutInternals },
  TableName extends DefaultSchemaTableNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals;
  }
    ? keyof DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions['schema']]['Tables']
    : never = never,
> = DefaultSchemaTableNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals;
}
  ? DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions['schema']]['Tables'][TableName] extends {
      Insert: infer I;
    }
    ? I
    : never
  : DefaultSchemaTableNameOrOptions extends keyof DefaultSchema['Tables']
    ? DefaultSchema['Tables'][DefaultSchemaTableNameOrOptions] extends {
        Insert: infer I;
      }
      ? I
      : never
    : never;

export type TablesUpdate<
  DefaultSchemaTableNameOrOptions extends
    | keyof DefaultSchema['Tables']
    | { schema: keyof DatabaseWithoutInternals },
  TableName extends DefaultSchemaTableNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals;
  }
    ? keyof DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions['schema']]['Tables']
    : never = never,
> = DefaultSchemaTableNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals;
}
  ? DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions['schema']]['Tables'][TableName] extends {
      Update: infer U;
    }
    ? U
    : never
  : DefaultSchemaTableNameOrOptions extends keyof DefaultSchema['Tables']
    ? DefaultSchema['Tables'][DefaultSchemaTableNameOrOptions] extends {
        Update: infer U;
      }
      ? U
      : never
    : never;

export type Enums<
  DefaultSchemaEnumNameOrOptions extends
    | keyof DefaultSchema['Enums']
    | { schema: keyof DatabaseWithoutInternals },
  EnumName extends DefaultSchemaEnumNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals;
  }
    ? keyof DatabaseWithoutInternals[DefaultSchemaEnumNameOrOptions['schema']]['Enums']
    : never = never,
> = DefaultSchemaEnumNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals;
}
  ? DatabaseWithoutInternals[DefaultSchemaEnumNameOrOptions['schema']]['Enums'][EnumName]
  : DefaultSchemaEnumNameOrOptions extends keyof DefaultSchema['Enums']
    ? DefaultSchema['Enums'][DefaultSchemaEnumNameOrOptions]
    : never;

export type CompositeTypes<
  PublicCompositeTypeNameOrOptions extends
    | keyof DefaultSchema['CompositeTypes']
    | { schema: keyof DatabaseWithoutInternals },
  CompositeTypeName extends PublicCompositeTypeNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals;
  }
    ? keyof DatabaseWithoutInternals[PublicCompositeTypeNameOrOptions['schema']]['CompositeTypes']
    : never = never,
> = PublicCompositeTypeNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals;
}
  ? DatabaseWithoutInternals[PublicCompositeTypeNameOrOptions['schema']]['CompositeTypes'][CompositeTypeName]
  : PublicCompositeTypeNameOrOptions extends keyof DefaultSchema['CompositeTypes']
    ? DefaultSchema['CompositeTypes'][PublicCompositeTypeNameOrOptions]
    : never;

export const Constants = {
  graphql_public: {
    Enums: {},
  },
  public: {
    Enums: {
      invitation_status: ['pending', 'accepted', 'declined', 'cancelled'],
      language: ['de', 'en'],
      math_operation: ['add', 'subtract', 'multiply', 'divide'],
      note_type: ['team', 'private'],
      notification_content_category: [
        'member_management',
        'project_information',
        'budget',
        'alert',
        'anomaly',
        'tracking',
      ],
      period_type: ['monthly', 'quarterly', 'yearly'],
      project_type: ['project', 'subproject_client', 'subproject_contractor'],
      stripe_status: [
        'active',
        'past_due',
        'canceled',
        'incomplete',
        'incomplete_expired',
        'trialing',
        'unpaid',
      ],
    },
  },
} as const;
